/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Alert, Button, FormControlLabel, Portal, Snackbar, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Styles from '../../css/ResetPasswordPage.module.css';
import EnvelopeWithBox from '../EnvelopeWithBox';
import ResetPasswordModal from '../modals/ResetPasswordModal';
import PasswordSecretQuestionModal from '../modals/PasswordSecretQuestionModal';
import LoadingModal from '../modals/LoadingModal';
import { maxEmailLength } from '../../common/constants';
import { isStrEmptyOrNull, isValidEmailAddress } from '../../common/UtilityFunctions';
import { useResetPasswordContext } from '../../contexts/ResetPasswordContext';

const ResetPasswordForm = () => {
  const resetPasswordContext = useResetPasswordContext();

  const navigate = useNavigate();

  return (
    <>
      <EnvelopeWithBox className={Styles.container} blockName={'Reset Password'}>
        <form className={Styles.form} onSubmit={resetPasswordContext.validateFields}>
          {resetPasswordContext.status === 'loading' && (
            <LoadingModal
              open={resetPasswordContext.status === 'loading'}
              loadingMessage={resetPasswordContext.loadingMessage}
            />
          )}
          {resetPasswordContext.resetPasswordModalOpen && <ResetPasswordModal />}
          {resetPasswordContext.passwordSecretQuestionModalOpen && <PasswordSecretQuestionModal />}
          <Portal>
            <Snackbar
              open={!!resetPasswordContext.statusAlert.message}
              onClose={() =>
                resetPasswordContext.setStatusAlert({
                  status: '',
                  message: '',
                })
              }
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              ClickAwayListenerProps={{ onClickAway: () => null }}
            >
              <Alert
                onClose={() =>
                  resetPasswordContext.setStatusAlert({
                    status: '',
                    message: '',
                  })
                }
                severity={resetPasswordContext.statusAlert.status as any}
                variant='filled'
                className={Styles.alert}
              >
                {resetPasswordContext.statusAlert.message}
              </Alert>
            </Snackbar>
          </Portal>
          <div className={Styles.flexCol}>
            <>
              <p>Please fill out your Email Address in order to reset your password.</p>
              <section className={Styles.gridContainer}>
                <TextField
                  fullWidth
                  size='small'
                  label='Email Address * '
                  placeholder='Email Address *'
                  error={resetPasswordContext.emailAddressError}
                  helperText={resetPasswordContext.emailAddressError ? resetPasswordContext.emailAddressErrorMsg : ' '}
                  value={resetPasswordContext.emailAddress}
                  inputProps={{
                    maxLength: maxEmailLength,
                  }}
                  onChange={(e) => {
                    resetPasswordContext.setEmailAddress(e.target.value);
                    resetPasswordContext.setEmailAddressError(!isValidEmailAddress(e.target.value));
                    resetPasswordContext.setEmailAddressErrorMsg(
                      isStrEmptyOrNull(e.target.value)
                        ? 'Please enter your Email Address.'
                        : 'Email Address provided is not valid.',
                    );
                  }}
                />
              </section>
              <FormControlLabel
                control={
                  <input
                    required
                    type='checkbox'
                    checked={resetPasswordContext.certified}
                    onChange={(e) => {
                      resetPasswordContext.setCertified(!resetPasswordContext.certified);
                      resetPasswordContext.setResetPasswordModalOpen(!resetPasswordContext.certified);
                    }}
                  />
                }
                className={Styles.text}
                label='I certify that I am an applicant on a loan.'
              />
            </>
          </div>
          <Button onClick={() => navigate(-1)} size='large' className={Styles.backButton}>
            Back
          </Button>
          <Button type='submit' size='large' className={Styles.button}>
            Submit
          </Button>
        </form>
      </EnvelopeWithBox>
    </>
  );
};

export default ResetPasswordForm;
